import { en as vuetifyEn } from 'vuetify/lib/locale'

export default {
	...vuetifyEn,
	loading: 'Loading...',
	web: {
		index: {
			login: "Sign In",
			sigupForFree: "Sign Up Free"
		},
		signin: {
			email: "Enter your email",
			password: "Enter your password"
		},
		signup: {
			email: "Enter your email",
			password: "Enter your password (8-20 characters)",
			repassword: "Confirm your password"
		},
		rules: {
			emailCount: "Must be at least 5 characters",
			passwordCount: "Must be 8 to 20 characters",
		},
		forgetpassword: {
			email: "Your email",
			code: "Verification code"
		},
		reset: {
			oldPassword: "Enter your current password",
			newPassword: "Enter your new password"
		}
	},
	common: {
		close: "Close",
		save: "Save",
		bye: "Goodbye",
		cancel: "Cancel",
		sure: "OK",
		back: "Back",
		refresh: "Refresh",
		update: "Update",
		later: "Maybe Later",
		add: "Add",
		clear: "Clear",
		inDevelopment: "In Development",
		items: "items",
		retry: "Retry All",
		unopened: "Coming soon",
		traffic: "Traffic",
		dayUnit: "{0}d",
		hourUnit: "{0}h",
		minUnit: "{0}m",
		secUnit: "{0}s"
	},
	home: {
		myDrives: "My Drives",
		transfer: "Cloud-to-Cloud Transfer",
		sync: "Cloud-to-Cloud Sync",
		myTasks: "Tasks",
		gift: "Pricing",
		resource: "Partner Links"
	},
	cloud: {
		new: "Cloud Storage",
		emptuyCloudList: "Your cloud drive list is empty",
		emptuyList: "Nothing here yet",
		newFolder: "New Folder",
		emptyFolder: "This folder is empty.",
		searchItem: "Search this folder",
		noMatch: "No matches found",
		invalidTip: "Authorization expired — please reconnect",
		oauthInvalid: "This cloud drive's authorization has expired. Please reconnect it.",
		refresh: "Refresh Capacity",
		update: "Rename",
		delete: "Disconnect and Remove",
		reloadAuth: "Reconnect",
		deletingCloud: "Disconnect and Remove",
		deleteTip: "Tasks currently running on this drive will be stopped and deleted if you remove it. Remove this drive anyway?",
		addSuccessTip: "Cloud drive connected",
		addExistTip: "Cloud drive authorization refreshed",
		addFailTip: "Failed to connect the cloud drive. Please contact our support team.",
		addSuccess: "Cloud drive added. Please return to the app and refresh your drive list.",
		addExplain: "Click any of the available drives below to connect it. You'll be redirected to the provider's authorization page to sign in.",
		endExplain: "We're working on supporting more cloud drives. If there's one you'd like to see, let us know via the message board — thank you for your support!",
		baidu: "Baidu Netdisk",
		chinamobile: "China Mobile Cloud",
		drive123: "123 Cloud",
		webdav: "WebDAV",
		tencent: "Tencent Weiyun",
		ftp: "FTP",
		jianguoyun: "Nutstore",
		drive115: "115 Drive",
		thunder: "Thunder Drive",
		wps: "WPS Cloud",
		ai360: "360 AI Drive",
		drive189: "China Telecom Cloud",
		quark: "Quark Drive",
		guangya: "Guangya Drive",
		aliyun: "Aliyun Drive",
		onedrive: "OneDrive",
		googleDrive: "Google Drive",
		dropbox: "Dropbox",
		future: "We plan to support more third-party cloud drives in the future. If there's one you'd like added, let us know by email. Coming later:",
		explorer: {
			myFiles: "My Files",
			name: "Name",
			size: "Size",
			updateTime: "Modified",
			open: "Open",
			refresh: "Refresh",
			delete: "Delete",
			preview: "Preview",
			rename: "Rename",
			mkdir: "New Folder",
			download: "Download",
			upload: "Upload",
			search: "Search",
			copyTo: "Transfer to",
			moveTo: "Move to",
			site: "Open Official Site",

		},
		file: {
			pic: "Images",
			vedio: "Videos",
			audio: "Audio",
			book: "Books"
		}
	},
	task: {
		new: "Tasks",
		title: "Task List",
		newTask: "New Task",
		deleteEmpty: "Clear List",
		empty: "Your task list is empty",
		restart: "Restart",
		continue: "Resume Transfer",
		resume: "Resume",
		delete: "Delete",
		completed: "File and Folder Success Rate",
		status: {
			running: "Running",
			waiting: "Waiting",
			success: "Success",
			failure: "Failed",
			lessSuccess: "Partially Successful",
			mostSuccess: "Mostly Successful",
			cancel: "Canceled",
			pause: "Paused",
			recover: "Resume",
			unkown: "Unknown"
		},
		delTitle: "Delete Task",
		delTip: "Are you sure you want to delete this task?",
		itemsSelected: "items selected",
		sourceNotSelect: "No source selected",
		destinationNotSelect: "No destination selected",
		createTip: "Transfers run in the cloud — check in anytime, from anywhere.",
		syncCreateTip: "Syncs run in the cloud. The default sync interval is 1 day."
	},
	transfer: {
		desc: "Transfer files and folders directly from one cloud drive to another — everything runs in the cloud, no need to stay online.",
		addNewCloud: "Add Cloud Storage",
		source: "Select Source",
		baiduPath: "/apps/QianClouds",
		baiduOldPath: "/apps/XiaomaiQianyun",
		baiduRoot: "You can only select the \"/My Apps/QianClouds\" folder and its subfolders",
		thunderLimit: "Thunder Drive is not currently supported as a source",
		destination: "Select Destination",
		setting: "Settings",
		chipLable: "Extensions, e.g. mp4",
		filterTip: "File type filters let you define include or exclude rules based on file extensions. Enter file types such as zip or jpg:",
		include: "Include the following file types",
		exclude: "Exclude the following file types",
		conflictTile: "File Conflict Policy",
		taskName: "Task Name",
		cloudTips: "Click a source or destination name to browse that drive or folder",
		sendEmail: "Email me the results when the task finishes",
		createNow: "Start Transfer",
		createSync: "Start Sync",
		inLine: "This task is queued",
		calculating: "Calculating",
		timeRemaining: "Estimated Time Remaining",
		rateTip: "Without SVIP, download speeds are typically limited by the provider. Small files may also appear slow to transfer because of their size.",
		shortSpeed: "",
		folder: "Folders",
		file: "Files",
		size: "Size",
		skipped: "Skipped",
		failed: "Failed",
		stopTitle: "Stop Task",
		stopTip: "Stop the task that is currently running?",
		stop: "Stop",
		cancel: "Cancel",
		loading: "Loading...",
		from: "Source",
		to: "Destination",
		total: "of",
		items: "items",
		stoppingTask: "Stopping task",
		taskSetting: "Task Settings",
		fileConfict: "File Conflict Policy",
		confictTip: "When a file conflict occurs during transfer, the policy you select below will be applied.",
		notificationEmail: "Notification Email",
		notificationPhoneTip: "Please enter your phone number",
		notificationEmailTip: "Please enter your email address",
		time: "Time",
		avgRate: "Average Speed",
		startTime: "Start Time",
		endTime: "End Time",
		failDetails: "Error Details",
		FailDetails: "Error List",
		path: "Path",
		cause: "Cause",
		conflict: {
			skip: "Skip the file if it already exists",
			rename: "Rename the file if it already exists",
			replace: "Overwrite the existing file",
		},
	},
	sync: {
		desc: "Keep a folder in one cloud drive in sync with a folder in another, on a regular schedule — everything runs in the cloud, no need to stay online.",
		resumeTitle: "Resume Sync",
		resumeTip: "Resume the sync now?",
		logTitle: "Sync Log",
		logEmpty: "No logs yet",
		logStart: "Start Time",
		logEnd: "End Time",
		logAdd: "Added",
		logDelete: "Deleted",
		logUpdate: "Updated"
	},
	user: {
		vipTipTitle: "Technical Support Feedback",
		vipNow: "Send Feedback",
		vipGroup: "Technical Feedback",
		vipDesc: "Scan the WeChat QR code below to report any issues or system problems — we'll respond as quickly as we can.",
		messageWant: "Leave a Message",
		messageBoardBut: "Message Board",
		changeAvatar: "Change Avatar",
		avatarPreview: "Preview",
		avatarUpload: "Upload Avatar",
		avatarUploadClick: "Click to Upload",
		orderList: "Order History",
		changePassword: "Change Password",
		resetPassword: "Change Password",
		newPassword: "Enter your new password",
		reNewPassword: "Re-enter your new password",
		checkPassword: "The two passwords don't match",
		newPasswordCheck: "Password must be 8-20 characters",
		oldPassword: "Enter your current password",
		oldPasswordCheck: "Password must be 8-20 characters",
		passwordLimit: "At least 8 characters",
		passwordSuccess: "Password changed successfully",
		showPassword: "Show",
		logout: "Sign Out",
		del: "Delete Account",
		switchLanguage: "Switch Language",
		langCn: "简体中文",
		langEn: "English",
		connectUs: "Submit a Ticket",
		start: "Start",
		feedback: "Feedback",
		passwordCheck: "Password must be 8-20 characters",
		unlimited: "Unlimited",
		sessionExpired: "Your session has expired. Please sign in again.",
		feedbackDescribe: "Thank you for using our product. If you run into any issues, email us and we'll get back to you within 24 hours. To help us resolve things faster, please include your account, a description of the problem, and any steps, screenshots, or videos that show what happened. Thank you!"
	},
	gift: {
		type: {
			MONTHLY: "Monthly Subscription"
		},
		compare: "Compare Plans",
		pricingTable: "Plans",
		subtitle: "Manage and protect your multi-cloud data · Professional · Secure · Trusted",
		subtitleDesc: "1TB of files = 1TB of traffic",
		orderDetails: "Order Details",
		describe: {
			dialogTitle: "QianClouds Service Agreement and Terms of Use",
			intro: "Please review how our service works before subscribing. QianClouds provides a compliant, secure channel for backing up and syncing data across cloud drives:",
			p1Title: "A Compliant, Secure Channel",
			p1Desc: "QianClouds is built on official provider APIs and does not offer any hacks that bypass provider speed limits. Your actual transfer speed and maximum file size depend on your membership tier with each cloud drive as well as your QianClouds plan.",
			p2Title: "Usage-Based Traffic, Transparent Billing",
			p2Desc: "Data transfers (uploads, downloads, syncs, backups, etc.) consume traffic at a 1:1 ratio based on actual data volume — transferring a 1GB file uses 1GB of traffic. Traffic packs can be purchased and stacked at any time.",
			p3Title: "Subject to Provider API Stability",
			p3Desc: "Cloud storage services are affected by provider policies and API fluctuations, so occasional connection delays may occur. We adapt to changes as quickly as possible.",
			expandHint: "View the detailed transfer limits for each cloud drive",
			detailTitle: "QianClouds Service Terms and Billing Rules",
			detailIntro: "Thank you for choosing QianClouds. To ensure the best backup and sync experience and to keep your account secure, please read the following service terms carefully:",
			d1Title: "1. What We Are and How We Keep You Safe",
			d1a: "QianClouds is a fully cloud-based platform for managing and safeguarding your data across multiple cloud drives. File backup, sync, and transfer services are provided through each provider's officially authorized APIs.",
			d1bTitle: "No Hacks, No Data Storage",
			d1b: "We never offer any service that bypasses provider restrictions or cracks membership benefits. QianClouds acts only as a data transfer channel and never stores your file contents, keeping your data private.",
			d1cTitle: "Speed and Permission Rules",
			d1c: "QianClouds provides the transfer channel and bandwidth quota, but download/upload speeds and single-file size limits follow each cloud drive's official rules. To unlock faster speeds or larger files, purchase the relevant membership from the provider directly.",
			d2Title: "2. Billing and Traffic Consumption",
			d2aTitle: "How Traffic Is Consumed",
			d2a: "When you use backup, sync, upload, or download features, traffic is consumed at a 1:1 ratio based on actual file size. For example, successfully transferring a 5GB video uses 5GB of traffic.",
			d2bTitle: "Traffic Validity",
			d2b: "All subscriptions are billed annually. Traffic packs can be purchased repeatedly and stacked; each pack is valid for 1 year from the date of purchase, and any unused traffic expires at the end of that period.",
			d2cTitle: "Task Retries",
			d2c: "If a task fails due to network issues or API errors and retries automatically, retries don't consume your traffic — traffic is only deducted for files transferred successfully. For reliability, we recommend testing the connection with a few files before running a large-scale sync.",
			d3Title: "3. Cloud Drive Transfer Limits at a Glance",
			d3Note: "To avoid confusion as providers update their rules, here are the typical limits currently applied to third-party tools like QianClouds. Always refer to each provider's latest policy for specifics.",
			tableNote: "If you see a \"file too large\" or \"speed limited\" error, it's usually because the provider restricts non-member or third-party API access. Check your membership status with that provider.",
			checkboxLabel: "I have read and understand the service terms above and confirm my purchase",
			orderBrief: "Data transfers (transfer, sync, upload, download, etc.) consume traffic at a 1:1 ratio based on actual file size — successfully transferring a 1GB file uses 1GB of traffic.",
		},
		currentPlan: "Current Plan",
		order: "Subscribe Now",
		vipDocument: "Premium Benefits",
		freeDocument: "Free Benefits",
		speedDesc: "Maximum transfer speed refers to the peak bandwidth QianClouds provides during transfers. Actual speeds depend on many factors, including the membership tiers of both source and destination accounts, the size of files in the transfer queue, server stability on both ends, and network conditions. We do not offer any way to bypass provider limits.",
		tabs: {
			combo: "Flexible Plans",
			retail: "Save with Annual",
		},

		subscriptionTitle: "Subscriptions",
		subscriptionDesc: "Your multi-cloud data manager — secure, simple, and efficient",
		trafficTitle: "Traffic Packs",
		trafficDesc: "Top up your transfer traffic and stack it with any subscription",
		trafficValid: "Traffic packs valid for 1 year · Stackable",

		comboDesc: "",
		comboSave: "Save",
		details: {
			a: '1. Listed speeds are the maximum supported under typical multi-file concurrency; actual speeds also depend on provider membership tiers, file sizes, and other factors.',
			b: '2. For unlimited plans, speeds may be reduced once total usage exceeds the designed threshold.',
			c: '3. Plan pricing and benefits may change over time. We reserve the right to modify plans and pricing.',
			d: "4. ",
			e: "Want to see how the plans compare in detail? "
		},
		a: {
			title: {
				size: "30G",
				ext: "",
				sale: "￥0",
				name: "Free Trial",
				number: "2312Free",
				speed: '2MB',
				time: "1st of each month",
				badge: "",
				id: "1"
			},
			color: "#9CA3AF",
			content: free()
		},
		b: {
			title: {
				size: "1TB",
				ext: "",
				sale: "￥24.8",
				originalSale: "￥29.8",
				name: "Monthly Basic",
				number: "1TB-M-26082",
				speed: '15MB',
				time: "1 month",
				badge: "Best Seller",
				id: "97"
			},
			color: "#4FA0B0",


			content: vip(15)
		},
		c: {
			title: {
				size: "100G",
				ext: "",
				sale: "￥8.8",
				name: "1-Day Pass",
				number: "100GB-D-2608",
				speed: '15MB',
				time: "1 day",
				badge: "",
				id: "96"
			},
			color: "#62c291",

			content: vip(15)

		},
		p: {
			title: {
				size: "Unlimited",
				ext: "",
				sale: "￥998",
				originalSale: "￥1298",
				name: "Lifetime",
				number: "Unlimit-Forever-2609",
				speed: '15MB',
				time: "Lifetime",
				badge: "",
				id: "108"
			},
			color: "#3f5db6",

			content: vip(15, 80, 8, true)

		},

		d: {

			title: {
				size: "Unlimited",
				ext: "",
				sale: "￥128",
				name: "Quarterly Lite",
				number: "Lite-Unlimit-3M-2608",
				speed: '8MB',
				time: "3 months",
				badge: "",
				id: "100",
				start: "2026-08-24"
			},
			color: "#425794",

			content: vip(8, 20, 4)

		},
		h: {
			title: {
				size: "Unlimited",
				ext: "",
				sale: "￥168",
				name: "Quarterly Plus",
				number: "Unlimit-3M-2510",
				time: "3 months",
				speed: '15MB',
				badge: "Most Popular",
				id: "44"
			},
			color: "#6B4294",
			content: vip(15, 30, 8)

		},

		j: {
			title: {
				size: "Unlimited",
				ext: "",
				sale: "￥298",
				name: "Quarterly Turbo",
				number: "Fast-Unlimit/3Y",
				speed: '30MB',
				time: "3 months",
				badge: "",
				id: "101",
				start: "2026-08-24"
			},
			color: "#947B42",
			content: vip(30, 30, 15)
		},
		k: {
			title: {
				// TODO: 7th plan placeholder config — fill in real params (size/sale/name/number/speed/time/id/content)
				// and set start to the actual launch date (auto-shows at 00:00 that day, funnel row back to 3+3)
				size: "TBD",
				ext: "",
				sale: "￥0",
				name: "Coming Soon",
				number: "Placeholder-7th",
				speed: '15MB',
				time: "3 months",
				badge: "",
				id: "0",
				start: "2099-01-01"
			},
			color: "#4FB07F",
			content: vip(15)
		},
		m: {
			title: {
				size: "Unlimited",
				ext: "",
				sale: "￥428",
				name: "Yearly Plus",
				number: "Unlimit-Y-2608",
				time: "12 months",
				speed: '15MB',
				badge: "Best Value",
				id: "94"
			},
			color: "#253c98",
			content: vip(15, 80, 8)
		},
		y: {
			title: {
				size: "12TB",
				ext: "",
				sale: "￥148",
				name: "Yearly Lite",
				number: "12TB-Y-2608",
				time: "12 months",
				speed: '8MB',
				badge: "Light Annual",
				id: "102"
			},
			color: "#5E7CE0",
			content: vip(8)
		},
		z: {
			a: "Custom transfer speeds",
			b: "Custom features",
			c: "Parallel task execution",
			d: "Dedicated bandwidth channels",
			e: "Algorithms tuned to your workflows",
			f: "Fast, professional support",
			g: "Solutions tailored to your business"
		},

		other: {
			a: "1. Traffic included in all plans applies to transfers, syncs, backups, uploads, and downloads, consumed at a 1:1 ratio to file size — successfully transferring a 1GB file uses 1GB of traffic.",
			b: "2. We do not offer any way to bypass provider restrictions. All services depend on your account's official membership benefits with each provider; see their documentation for details.",
			c: "3. To keep the service running, plans may change over time. If a plan you purchased changes, existing subscribers can apply to switch at their original price or pay the difference toward a current plan. Thank you for your support!"
		},
		multi: {
			desc: "* Each purchase is valid for 1 year, and multiple purchases stack."
		},
	},
	addCloud: {
		clickAuth: "Click to connect this cloud drive",
		authTitle: "Sign in to {0}",
		scanSuccess: "[QR code scanned]",
		qrTip: "We're requesting API access to your {0} account, including listing files and file details, downloads, uploads, deletes, and renames. Scan the QR code to authorize.",
		uc: "UC Drive",
		connect123: "123 Cloud Standard Connection",
		devTip123: "Go to the 123 Cloud website and purchase the Developer pack. 123 Cloud will then send your client_id and client_secret via in-site messages.",
		viewTutorial: "View Tutorial",
		connect: "Connect",
		address: "Address:",
		username: "Username:",
		secret: "Secret:",
		connectService: "Connect to Service",
		normalConnect: "Standard Connection",
		protocol: "Protocol (I):",
		host: "Host (H):",
		port: "Port (P):",
		loginType: "Login Type (L):",
		user: "User (U):",
		password: "Password (W):",
		keyFile: "Key File (K):",
		chooseFile: "Choose File",
		webdavConnect: "WebDAV Standard Connection",
		serviceAddr: "Service Address:",
		preparing: "Preparing the authorization window, please wait",
		comingSoon: "Work in progress — coming soon",
		limitTitle: "Premium Feature",
		limitVipCloud: "Upgrade to a paid plan to add this cloud drive, or choose a different one",
		completeInfo: "Please complete the form",
		fillToken: "Please enter your token",
		reachLimit: "Drive Limit Reached",
		reachLimitDesc: "You've reached the maximum number of connected cloud drives. To connect more, upgrade your plan using the button below. Thank you for your support!",
		publicIpOnly: "Only public IP addresses are supported",
		tab: {
			dev: "Developer Mode",
			webdav: "WebDAV"
		},
		ftpType: {
			normal: "Password",
			keyFile: "Key File"
		}
	},
	explorer: {
		uploading: "Uploading",
		cancelUpload: "Cancel Upload",
		downloadList: "Downloads",
		deleteFile: "Delete File",
		deleteTip: "Move this to the recycle bin?",
		serverFail: "Couldn't reach the server. Please try again.",
		uploadSuccess: "Upload successful",
		oneDownload: "1 download already in progress",
		over2G: "For files over 2GB, please use the provider's desktop app",
		canceled: "Canceled",
		noDirPicker: "Your browser doesn't support folder selection. Please use Chrome 86+ or Edge 86+."
	},
	copyTo: {
		selectDest: "Select Destination",
		limitTitle: "Premium Feature",
		folderLimit: "Free plans can't transfer folders. Upgrade your subscription or select individual files.",
		quotaLimit: "Your remaining traffic isn't enough for this task. Please upgrade your subscription or choose fewer files."
	},
	order: {
		orderNo: "Order No.",
		orderNoColon: "Order No.: {0}",
		createTimeLabel: "Created",
		orderDate: "Order Date",
		records: "Order History",
		plan: "Plan",
		daysCol: "Days",
		amountYuan: "Amount (CNY)",
		statusCol: "Status",
		payPending: "Pending Payment",
		payStatusSuccess: "Paid",
		duration: "Duration",
		quotaCapacity: "Traffic Capacity",
		includesQuota: "Traffic Included",
		validity: "Validity",
		days: "{0} days",
		forever: "Forever",
		lifetime: "Lifetime",
		inclQuota: "({0} traffic included)",
		addonTitle: "Add-On Traffic Packs",
		addonHint: "Bundle and save",
		addonValid: "All traffic packs valid for 1 year · Stackable",
		addonOnly: "Add-on for just {0}",
		addonPack: "Add a {0} traffic pack",
		payAmount: "Total",
		save: "Save ￥{0}",
		serviceTitle: "QianClouds Service Terms",
		viewDetails: "View Details",
		wechatPay: "WeChat Pay",
		alipayPay: "Alipay",
		encourage: "Thank you for your support — we'll keep making QianClouds better!",
		wechatScanPay: "Scan to Pay with WeChat",
		alipayScanPay: "Scan to Pay with Alipay",
		qrGenerating: "Generating QR code...",
		payDone: "Payment Successful",
		payUnfinished: "Payment Not Completed",
		scanned: "QR code scanned",
		confirmOnPhone: "Please confirm the payment on your phone",
		scannedWaiting: "QR code scanned, waiting for payment...",
		wechatName: "WeChat",
		alipayName: "Alipay",
		scanPrefix: "Scan with",
		scanSuffix: "to pay",
		remain: "{0} remaining",
		done: "Done",
		downloadQr: "Download QR Code",
		payTimeout: "Payment timed out. Please start a new payment.",
		wechatNotReady: "WeChat Pay is still in development — please pay with Alipay",
		openInWechat: "Please open this page in WeChat to pay",
		h5Unavailable: "In-app payment is unavailable — please scan the QR code instead",
		discountCodeInvalid: "Please enter a valid 8-character discount code",
		invalidOrderNo: "Invalid order number",
		alreadyDiscounted: "This order is already discounted",
		verifySuccess: "Code verified",
		limitTable: {
			platform: "Cloud Drive",
			sizeLimit: "Max File Size (Third-Party API)",
			speedNote: "What Affects Transfer Speed"
		},
		limit: {
			aliPlatform: "Aliyun Drive",
			aliLimit: "Limited by the provider's third-party API package",
			aliNote: "Requires a third-party app traffic package from Aliyun Drive",
			p123Platform: "123 Cloud",
			p123Limit: "Provider member limit (10GB)",
			p123Note: "Depends on your 123 Cloud membership tier",
			baiduPlatform: "Baidu Netdisk",
			baiduLimit: "Official SVIP limit (20GB)",
			baiduNote: "Depends on your Baidu Netdisk SVIP tier",
			p115Platform: "115 Drive",
			qcLimit: "Limited by your QianClouds plan",
			p115Note: "Depends on 115 Drive's official benefits and your QianClouds plan",
			quarkPlatform: "Quark Drive",
			quarkNote: "Depends on Quark Drive's official benefits and your QianClouds plan",
			xunleiPlatform: "Thunder Drive",
			xunleiNote: "Depends on Thunder Drive's official benefits and your QianClouds plan",
			oneDrivePlatform: "OneDrive",
			odNote: "Depends on OneDrive's official limits and your QianClouds plan",
			guangyaPlatform: "Guangya",
			guangyaNote: "Depends on Guangya's official benefits and your QianClouds plan"
		}
	},
	mineHome: {
		slogan: "Your multi-cloud data, safer and free to move",
		needHelp: "Need help?",
		wechatContact: "Contact Us on WeChat",
		wechatService: "WeChat Support",
		wechatServiceTip: "Scan the QR code to add our WeChat support for dedicated assistance",
		messagePlaceholder: "Leave your contact info and we'll reach out...",
		messageEmpty: "Please tell us what you need help with",
		messageSuccess: "Message sent",
		normalUser: "Free Plan Benefits",
		expireAt: "Expires {0}",
		paidQuota: "Paid Traffic",
		freeQuota: "Free Traffic",
		addonQuota: "Add-On Traffic",
		quotaUsedUp: "Traffic used up · Expires {0}",
		upgrade: "Upgrade Plan",
		goAuth: "Connect a Drive",
		storageUnknown: "Storage unknown",
		inviteTitle: "Invite Friends to Sign Up",
		inviteDesc: "Earn up to 5TB per month",
		renamePlaceholder: "Enter a name",
		confirm: "Confirm",
		lifetimeUnlimited: "Lifetime Unlimited",
		vipMember: "Subscriber",
		vipBenefit: "Subscription Benefits",
	},
	profile: {
		title: "Profile",
		nickname: "Nickname",
		edit: "Edit",
		newNickname: "Enter a new nickname",
		phone: "Phone",
		unbound: "Not linked",
		bound: "Linked",
		changeBind: "Change",
		goBind: "Link",
		wechat: "WeChat",
		loginMethodsTip: "Sign in with phone + code, phone + password, account + password, WeChat, and more",
		wechatBindTitle: "Link WeChat",
		wechatScanTip: "Scan the QR code with WeChat to link your account",
		nicknameEmpty: "Nickname can't be empty",
		nicknameSuccess: "Nickname updated",
		required: "Required.",
		delReasonTip: "Tell us why you're leaving...",
		delReasonRequired: "Please tell us why",
		delBye: "Sorry to see you go. Thanks for your support!",
	},
	wechatResult: {
		success: "WeChat linked successfully",
		fail: "Failed to link WeChat",
		successDesc: "You can now sign in to this account by scanning the QR code with WeChat",
		occupiedDesc: "This WeChat account is already linked to another account",
		expiredDesc: "The QR code has expired. Please go back to your profile and try again.",
		failDesc: "Something went wrong. Please go back to your profile and try again.",
		back: "Back to Console",
	},
	mpAuth: {
		success: "Cloud drive connected",
		fail: "Failed to connect the cloud drive",
		successDesc: "Please return to the WeChat mini program — your drive list will update automatically",
		failDesc: "Please return to the WeChat mini program and try again",
	},
	transferList: {
		progress: "Progress",
		lessThan: "Less than {0}",
		sourceRateTip: "Downloads may be slow if the source drive's account doesn't have VIP benefits.",
		highSpeedQuota: "High-Speed Traffic",
		continueSpeedup: "Keep Boosting",
		skip: "Skip",
		tooFast: "Please slow down — too many clicks",
		speedupDesc: "Upgrade your plan for a high-speed cloud channel that runs 24/7 — fast and hassle-free.",
		quotaDesc: "You're running low on traffic. Upgrade your subscription for more benefits.",
	},
	transferDetails: {
		skip: "Skipped",
		skipCount: "{0}",
		view: "View ({0})",
		encrypted: "Transferring securely:",
		paused: "Paused",
		calculating: "Calculating...",
		instant: "Instant transfer",
		waiting: "Waiting",
	},
	buildTransfer: {
		fullBackup: "Full Backup",
		tabFile: "Files",
		tabFilter: "Filters",
		tabMessage: "Notifications",
	},
	syncList: {
		timerSetting: "Schedule",
		nextFirePrefix: "Next sync: ",
		remaining: "{0} left",
		secUnit: "{0}s",
		hourUnit: "{0}h",
		minUnit: "{0}m",
		hourMin: "{0}h {1}m",
		compareInfo: "({0} items, {1})",
		executeInfo: "({0}%, {1}/s)",
		executeZero: "(0.00%)",
	},
	syncDetails: {
		oneWay: "One-Way Sync",
		twoWay: "Two-Way Sync",
		syncDone: "Sync Complete",
		stopped: "Stopped",
		comparing: "Comparing",
		deleted: "Deleted",
	},
	buildSync: {
		selectSource: 'Please select a source folder',
		setTimerFirst: 'Set a schedule first — choose Run Now or add a schedule before creating the task',
		noPlanTip: 'You have no schedules configured. Click "Schedule" to add one.',
		vipDesc: "This is a premium feature",
	},
	timer: {
		plan: "Schedule",
		planMax: "Schedules (up to {0})",
		planName: "Schedule {0}",
		executeNow: "Run Once Now",
		executeNowDesc: "Run the task immediately after creation",
		planOnlyDesc: "Run only on schedule",
		day: "Daily",
		week: "Weekly",
		month: "Monthly",
		weekDay1: "Mon",
		weekDay2: "Tue",
		weekDay3: "Wed",
		weekDay4: "Thu",
		weekDay5: "Fri",
		weekDay6: "Sat",
		weekDay7: "Sun",
		monthDay: "Day",
		execute: "Run",
		repeat: "Repeat",
		duplicateTip: "An identical schedule already exists. Please modify it.",
		addPlan: "Add Schedule",
		emptyPlan: "No schedules configured",
		timezone: "Time zone: {0}",
		confirmStart: "Start Now",
	},
	setting: {
		tab: {
			file: "Files",
			filter: "Filters",
			notify: "Notifications",
		},
		quickTags: "Quick Picks",
		notifyTip: "When a task finishes, we'll notify you through the channels selected below",
		sendEmail: "Send Email",
	},
	taskPage: {
		refreshList: "Refresh List",
		transferTab: "Transfer Tasks",
		syncTab: "Sync Tasks",
		offlineTip: "Tasks keep running in the cloud — you can safely close this page or shut down your computer.",
	},
	giftUi: {
		currentSub: "Current Subscription",
		maxSpeed: "Max Transfer Speed",
		limitedTime: "Limited time {0}",
		noOrder: "No purchase needed",
		benefitView: "View Benefits",
		benefitTitle: "About Benefits",
	},
	giftV2: {
		limitedSub: "Limited Subscription",
		unlimitedSub: "Unlimited Subscription",
		limitedTime: "Limited time {0}",
		legacyVipTip: "Existing subscribers can switch to a current plan by paying the difference or converting at their original price. Just submit a support ticket with your contact info.",
	},
	promo: {
		title: "New User Exclusive Offer",
		quotaLabel: "Transfer Traffic",
		durationLabel: "Validity",
		remain: "Offer ends in {0}",
		buyNow: "Claim Offer",
		later: "Maybe Later",
	},
	regGift: {
		claim: "Claim Now",
		claimed: "Claimed",
	},
	newUserTraffic: {
		title: "Welcome Gift for New Users",
		descPrefix: "Every new user gets",
		freeMonthly: "5GB/month",
		descMid: "of free traffic. Sign in the day after registering to earn an extra",
		descSuffix: "of free traffic for the month",
	},
	invite: {
		heroTitle: "Invite Friends, Earn Traffic",
		heroSub: "For every friend who signs up, you get {0} and your friend gets {1} in traffic rewards. This offer runs indefinitely.",
		step1Title: "Invite Friends to Sign Up",
		step1Desc: "Copy your invite link and share it on social media. When friends sign up through your link, you both earn rewards.",
		step2Title: "Your Friend Gets {0}",
		step2Desc: "Once a friend signs up through your link, they immediately receive {0} in add-on traffic, valid for 30 days.",
		step3Title: "You Get {0}",
		step3Desc: "When a friend signs up through your link, you immediately receive {0} in traffic, valid for 1 year. Rewards stack across multiple invitees, up to {1} per month. This offer runs indefinitely.",
		copyLink: "Copy Invite Link",
		longtermTip: "Runs indefinitely · Share anytime",
		monthCount: "This Month",
		totalCount: "Total Invites",
		totalGain: "Total Earned",
		records: "Invite History",
		peopleCount: "{0} people",
		registered: "Signed Up",
		emptyTitle: "No invites yet",
		emptyDesc: "Copy your invite link and share it with friends to start earning traffic",
		rulesTitle: "How It Works",
		rule1: "When a friend signs up through your invite link, you both earn traffic",
		rule2: "You can earn rewards for up to {0} invitees per month. Beyond that, your friends still get their rewards.",
		rule3: "Rewards are credited as add-on traffic, valid for 1 year, and stack monthly.",
		loadFail: "Couldn't load your invite info",
		copied: "Copied",
		shareText: "I use QianClouds to manage all my cloud drives — it supports transfers between 12 services including Aliyun Drive and Baidu Netdisk, with offline transfers that don't use your local bandwidth. Sign up with my link and get {0} of free traffic!",
		monthDay: "{0}/{1}",
		dialogTitle: "Invite Friends — You Both Earn Traffic",
		inviteCode: "Invite Code",
		shareLink: "Share Link",
		copy: "Copy",
		monthInvited: "Invited This Month",
		progressCount: "{0} / {1} people",
		totalQuota: "Total Traffic Earned",
		copyShareText: "Copy Share Message",
	},
	resource: {
		empty: "No links yet",
		disclaimer: "Third-party website disclaimer: The links on this page lead to third-party websites. Their accuracy, security, and legality are the responsibility of those websites. QianClouds is not liable for any consequences of visiting third-party websites — please use your own judgment and proceed at your own risk.",
		kkgyName: "Kuku Guangying",
		kkgyDesc: "An all-in-one search engine for cloud drive resources, aggregating links from Baidu Netdisk, Quark Drive, UC Drive, Thunder Drive, and other popular platforms. Search for movies, documents, software, games, and more — find what you need without hopping between platforms.",
	},
	backup: {
		title: "Cloud Drive Backup",
		titleSoon: "Cloud Drive Backup (coming in the next release)",
		a: "1. Back up any cloud drive to one or more other drives in a single pass.",
		b: "2. Each backup creates a dated version, so you can restore from any point in time.",
		c: "3. Set up scheduled backup plans with custom cycles, keep the last N versions, and automatically free up backup space.",
		d: "4. Includes file conflict policies, filters, notifications, traffic alerts, and storage space alerts.",
		support: "Please consider supporting us — every bit helps.",
	},
	help: {
		title: "Submit a Ticket",
		descLabel: "Describe the Issue",
		descPlaceholder: "Please describe the problem in detail...",
		descLimit: "Up to 500 characters",
		uploadLabel: "Upload Screenshot (optional)",
		uploadClick: "Click to Upload an Image",
		contactLabel: "Contact (WeChat or Email)",
		contactPlaceholder: "Enter your WeChat ID or email",
		submit: "Submit Ticket",
		toastSize: "Image must be under 5MB",
		toastDescRequired: "Please describe the issue",
		toastDescLimit: "Description must be under 500 characters",
		toastContactRequired: "Please enter your contact info",
		toastSuccess: "Ticket submitted — we'll get back to you soon",
		toastFail: "Submission failed. Please try again later.",
	},
	robot: {
		name: "Xiaomai",
		newChat: "New Chat",
		inputPlaceholder: "Type a message...",
		thinking: "Thinking...",
	},
	bind: {
		title: "Link Your Phone Number",
		phonePlaceholder: "Your phone number",
		codePlaceholder: "Verification code",
		resend: "Resend ({0})",
		sendCode: "Send Code",
		bound: "Linked: {0}",
		change: "Change",
		invalidPhone: "Invalid phone number",
		codeLength: "6-digit verification code",
		invalidPhoneNum: "Invalid phone number",
		invalidCode: "Invalid verification code",
		success: "Phone number linked",
	},
	preview: {
		zoomOut: "Zoom Out",
		zoomIn: "Zoom In",
		reset: "Reset",
		hint: "Scroll to zoom · Drag to pan · ESC to close",
		fallback: "Image Preview",
	},
	guide: {
		step1Title: "Step 1: Add Cloud Drives",
		step1Desc: "Pick the drives you want to manage and click to connect them. Aliyun Drive, Baidu Netdisk, 115 Drive, and more are supported.",
		step2Title: "Step 2: Manage Your Files",
		step2Desc: "Browse, download, upload, and manage files across your drives. Create folders, rename files, search, and more.",
		step3Title: "Step 3: Create a Cloud-to-Cloud Transfer",
		step3Desc: "Pick a source and a destination, then create a transfer task with one click to move files between cloud drives.",
		menuTitle: "File Actions Menu",
		menuDesc: "Click a file or folder to open this menu.",
		next: "Next",
		prev: "Back",
		done: "Done",
		skip: "Skip",
	},
	http: {
		maintaining: "The service is under maintenance. Please try again in a few minutes.",
		networkError: "Network connection error",
	},
	taskShow: {
		etc: " +{0} more",
	},
}
function free() {
	return {
		a: "Selected cloud drives only",
		b: "Online drive management",
		c: "Up to 2 cloud drives",
		w: "Cloud-to-cloud transfer",
		d: "Single files only",
		e: "Files up to 10GB",
		f: "Up to 2MB/s transfer speed",
	}
}

function vip(speed, limit, limitSpeed, forever) {
	let data = {
		a: "All supported cloud drives",
		b: "Online drive management",
		p: "Connect up to 10 cloud drives",
		o: "Automatic task queueing",
		c: "Cloud-to-cloud transfer",
		d: "Folder transfers",
		f: "Single files up to 100GB",
		h: "Up to " + speed + "MB/s transfer speed",
		k: "Instant file transfer",
		g: "Smart parallel transfers",
		w: "Cloud-to-cloud sync",
		z: "Daily, weekly, and monthly schedules",
		y: "Priority support tickets"
	}
	if (limit) {
		data.l = "Speed lowers to " + limitSpeed + "MB/s after " + limit + "TB used";
		if (forever) {
			data.l = "Speed lowers to " + limitSpeed + "MB/s after " + limit + "TB per year";
		}
	}

	return data
}
